<template>
  <div class="container pt-3">
    <div class="mb-6 px-5 mb-6">
      <div class="rounded has-background-primary-light mb-4">
        <div class="header-container rounded">
          <div class="hero-body pt-6 pb-5">
            <div class="header">
              <div class="columns is-multiline is-centered">
                <div class="column is-10-widescreen has-text-centered">
                  <div
                    class="gradient-text title is-3 is-size-4-mobile has-text-white has-text-weight-semibold fade-in-bottom"
                  >
                    Property & Facility Management
                  </div>
                  <p
                    class="mt-1 is-size-6 has-text-dark fade-in-bottom animation-delayer-02s has-text-weight-medium"
                  >
                    Looking to rent out your property in Kuala Lumpur or
                    Selangor on Airbnb and various platforms?
                  </p>
                  <p
                    class="mt-1 is-size-6 has-text-dark fade-in-bottom animation-delayer-02s has-text-weight-semibold"
                  >
                    Our expert team is here to transform, market, and manage
                    your property, helping you earn extra income or grow your
                    rental business with ease.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="scrolling-images mb-6">
        <div class="scroll-wrapper">
          <div
            v-for="(image, index) in images.concat(images)"
            :key="index"
            class="column is-narrow is-centered px-1"
          >
            <b-image
              class="rounded"
              :src="require(`@/assets/property-images/${image.src}`)"
              :style="`margin-bottom: ${image.adjustPosition}`"
              style="width: 200px; background: #f5f5f5"
            />
          </div>
        </div>
      </div>

      <div class="mb-6">
        <h1
          class="is-hidden-mobile title has-text-centered is-3 has-text-dark has-text-weight-semibold fade-in-bottom mb-6"
        >
          We manage. You earn.
        </h1>
        <h1
          class="is-hidden-tablet title has-text-centered is-3 has-text-dark has-text-weight-semibold fade-in-bottom mb-6"
        >
          We manage.<br />
          You earn.
        </h1>

        <div class="columns is-multiline">
          <div class="column has-text-centered right-separator">
            <div
              class="has-text-centered is-flex is-justify-content-center mb-5 py-1 px-6"
            >
              <b-image
                class="px-1 illustration"
                :src="require(`@/assets/undraw/max-earning.svg`)"
                style="height: 100%"
              />
            </div>
            <h2 class="title is-5">Maximize Earnings</h2>
            <p class="is-size-7 has-text-gray-3 px-6">
              Maximize your income with short-term rentals, which outperform
              traditional leases. We optimize your strategy for the best
              returns.
            </p>
          </div>
          <div class="column has-text-centered right-separator">
            <div
              class="has-text-centered is-flex is-justify-content-center mb-5 py-1 px-6"
            >
              <b-image
                class="px-1 illustration"
                :src="require(`@/assets/undraw/hassle-free.svg`)"
                style="height: 100%"
              />
            </div>
            <h2 class="title is-5">Hassle-Free</h2>
            <p class="is-size-7 has-text-gray-3 px-6">
              We take care of marketing, cleaning, maintenance, and billing, you
              can relax while we manage your property efficiently.
            </p>
          </div>
          <div class="column has-text-centered">
            <div
              class="has-text-centered is-flex is-justify-content-center mb-5 py-1 px-6"
            >
              <b-image
                class="px-1 illustration"
                :src="require(`@/assets/undraw/transparency.svg`)"
                style="height: 100%"
              />
            </div>
            <h2 class="title is-5">Transparency</h2>
            <p class="is-size-7 has-text-gray-3 px-6">
              You can track every booking, transaction, and guest interaction,
              giving you peace of mind while staying informed.
            </p>
          </div>
        </div>
      </div>

      <h1
        class="title has-text-centered is-3 has-text-dark has-text-weight-semibold fade-in-bottom mb-6"
      >
        Our Services
      </h1>
      <div class="columns is-multiline mb-6">
        <div
          class="column is-4-desktop is-6-tablet is-12-mobile"
          v-for="feature in features"
          :key="feature.title"
        >
          <div
            class="card accented-border-radius secondary-elevation feature-card"
            style="height: 100%"
          >
            <div
              class="card-header no-elevation has-background-primary-light py-4 px-6"
              style="height: max-content"
            >
              <b-image
                class="service px-1 mx-auto"
                :src="require(`@/assets/${feature.image}`)"
                style="height: 100%"
              />
            </div>
            <div class="card-content has-text-left">
              <p class="title is-5 mb-2 has-text-dark-gray">
                {{ feature.title }}
              </p>
              <p class="has-text-gray-3 pb-6 is-size-6">
                {{ feature.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-6">
        <h1 class="has-text-centered title is-3 has-text-dark-gray mb-5">
          Our Partners
        </h1>
        <div class="scrolling-images">
          <div class="scroll-wrapper">
            <div
              v-for="(partnerImage, index) in partnerImages.concat(
                partnerImages
              )"
              :key="index"
              class="column is-narrow is-centered"
            >
              <b-image
                class="px-1"
                :src="require(`@/assets/${partnerImage.src}`)"
                :alt="partnerImage.name"
                :style="`margin-bottom: ${partnerImage.adjustPosition}`"
                style="width: 150px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        { src: "image-1.png" },
        { src: "image-2.png" },
        { src: "image-3.png" },
        { src: "image-4.png" },
        { src: "image-5.png" },
      ],
      features: [
        {
          title: "Makeover and Furnishing",
          description:
            "Transform and furnish your properties to increase their appeal and value.",
          image: "service-1.svg",
        },
        {
          title: "Listing and Marketing",
          description:
            "Showcase your properties on multiple platforms and reach a broader audience.",
          image: "service-2.svg",
        },
        {
          title: "Legal Contract and Insurance",
          description:
            "Manage legal contracts and insurance policies with ease to protect your assets.",
          image: "service-3.svg",
        },
        {
          title: "Maintenance, Cleaning, and Inventory",
          description:
            "Organize property maintenance, cleaning services, and inventory tracking efficiently.",
          image: "service-4.svg",
        },
        {
          title: "Internet and Entertainment",
          description:
            "Set up high-speed internet and entertainment services for your tenants' comfort.",
          image: "service-5.svg",
        },
        {
          title: "Automate Financial Management",
          description:
            "Automate collection, payments, and financial records for seamless management.",
          image: "service-6.svg",
        },
      ],
      partnerImages: [
        { name: "Airbnb", src: "airbnb-logo.png" },
        {
          name: "Booking",
          src: "booking-logo.png",
        },
        { name: "Agoda", src: "agoda-logo.png" },
        { name: "Trip", src: "trip-logo.png" },
        {
          name: "Traveloka",
          src: "traveloka-logo.png",
        },
        {
          name: "Time Internet",
          src: "time-logo.svg",
        },
        {
          name: "Unifi Internet",
          src: "unifi-logo.svg",
        },
        { name: "Allianz Insurance", src: "allianz-logo.svg" },
      ],
    };
  },
};
</script>

<style>
.gradient-text {
  background: linear-gradient(90deg, #404fff, #00e2ae);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.right-separator {
  border-right: 1px solid #ccc;
}

.illustration {
  img {
    height: 120px !important;
    width: auto;
  }
}

.feature-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease-in-out;
}

.feature-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1);
}

.service {
  img {
    height: 120px !important;
    margin-left: auto !important;
  }
}
@media (max-width: 768px) {
  .right-separator {
    border-right: 0px solid #fff;
  }
}
</style>
